import { render, staticRenderFns } from "./CampoChoice.vue?vue&type=template&id=7ec3902e&"
import script from "./CampoChoice.vue?vue&type=script&lang=js&"
export * from "./CampoChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports